export const PLFILTER_TYPE_SERVICE = 'TYPE_SERVICE';
export const PLFILTER_TYPE_AGENT = 'TYPE_AGENT';
export const PLFILTER_TYPE_PHOTOGRAPHER = 'TYPE_PHOTOGRAPHER';
// export const PLFILTER_TYPE_EDITING_COMPANIES = 'TYPE_EDITING_COMPANIES';
// export const PLFILTER_TYPE_EDITORS = 'TYPE_EDITORS';
// export const PLFILTER_TYPE_AFFILIATES = 'TYPE_AFFILIATES';
export const PLFILTER_TYPE_FINANCE = 'TYPE_FINANCE';

export const ORDER_BY_SERVICE = {
	SERVICE_DATE: 'serviceDate',
	CREATED_AT: 'createdAt',
	UPDATED_AT: 'updatedAt'
};
